/* CHIKLETTE — tiroir panier connecté au panier Shopify.
   Le contenu est re-rendu par Shopify (API Section Rendering) : les prix
   restent donc toujours dans la devise du marché choisi par le visiteur. */
(function () {
  "use strict";

  var drawer = document.getElementById("cartDrawer");
  if (!drawer) return;

  var panelEl = drawer.querySelector(".cart-panel");
  var scrim = drawer.querySelector(".cart-scrim");
  if (!panelEl) return;

  var sectionId = drawer.getAttribute("data-section-id") || "";
  var cartUrl = drawer.getAttribute("data-cart-url") || "/cart";
  var addUrl = drawer.getAttribute("data-cart-add-url") || "/cart/add";
  var changeUrl = drawer.getAttribute("data-cart-change-url") || "/cart/change";

  var supportsFetch = typeof window.fetch === "function" && typeof window.DOMParser === "function";
  var busy = false;

  /* ---------- Ouverture / fermeture ---------- */
  var lastFocused = null;

  function isOpen() {
    return drawer.classList.contains("is-open");
  }

  function open() {
    if (isOpen()) return;
    lastFocused = document.activeElement;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var closeBtn = panelEl.querySelector(".cart-close");
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!isOpen()) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
  }

  /* ---------- Mise à jour du contenu ---------- */
  function syncHeaderCount() {
    var title = panelEl.querySelector(".cart-head__title");
    if (!title) return;
    var label = title.textContent.trim();
    document.querySelectorAll(".cart-toggle").forEach(function (toggle) {
      toggle.textContent = label;
    });
  }

  function applySection(html) {
    if (!html) return;

    var parsed = new DOMParser().parseFromString(html, "text/html");
    var fresh = parsed.querySelector(".cart-panel");
    if (!fresh) return;

    // On remplace l'intérieur du panneau, jamais le panneau lui-même :
    // l'état ouvert/fermé et les écouteurs d'événements sont préservés.
    panelEl.innerHTML = fresh.innerHTML;
    syncHeaderCount();
  }

  function setBusy(state) {
    busy = state;
    panelEl.setAttribute("aria-busy", state ? "true" : "false");
  }

  function fallbackToCartPage() {
    window.location.href = cartUrl;
  }

  /* ---------- Quantité et suppression ---------- */
  function changeLine(key, quantity) {
    if (busy) return;
    setBusy(true);

    fetch(changeUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart/change a échoué");
        return res.json();
      })
      .then(function (data) {
        applySection(data.sections && data.sections[sectionId]);
        setBusy(false);
      })
      .catch(function () {
        setBusy(false);
        fallbackToCartPage();
      });
  }

  panelEl.addEventListener("click", function (event) {
    var closeBtn = event.target.closest(".cart-close");
    if (closeBtn) {
      close();
      return;
    }

    var btn = event.target.closest("[data-act]");
    if (!btn || !supportsFetch) return;

    var row = btn.closest(".cart-item");
    var valueEl = row && row.querySelector(".qty__val");
    if (!row || !valueEl) return;

    var key = row.getAttribute("data-key");
    var quantity = parseInt(valueEl.textContent, 10);
    if (!key || isNaN(quantity)) return;

    var act = btn.getAttribute("data-act");
    if (act === "plus") changeLine(key, quantity + 1);
    else if (act === "minus") changeLine(key, Math.max(0, quantity - 1));
    else if (act === "remove") changeLine(key, 0);
  });

  document.querySelectorAll(".cart-toggle").forEach(function (toggle) {
    toggle.addEventListener("click", open);
  });
  if (scrim) scrim.addEventListener("click", close);
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") close();
  });

  /* ---------- Ajout au panier, sans rechargement ---------- */
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute("action") || "").indexOf("/cart/add") === -1) return;
    if (!supportsFetch) return; // navigateur ancien : soumission classique

    event.preventDefault();
    if (busy) return;

    var submitBtn = form.querySelector('[type="submit"]');
    var initialLabel = submitBtn ? submitBtn.textContent : "";

    function restoreButton() {
      if (!submitBtn) return;
      submitBtn.disabled = false;
      submitBtn.textContent = initialLabel;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = drawer.getAttribute("data-adding-label") || "Ajout…";
    }
    setBusy(true);

    var payload = new FormData(form);
    payload.append("sections", sectionId);

    fetch(addUrl + ".js", { method: "POST", headers: { Accept: "application/json" }, body: payload })
      .then(function (res) {
        if (!res.ok) throw new Error("cart/add a échoué");
        return res.json();
      })
      .then(function (data) {
        applySection(data.sections && data.sections[sectionId]);
        setBusy(false);
        restoreButton();
        open();
      })
      .catch(function () {
        setBusy(false);
        restoreButton();
        form.submit(); // repli : parcours Shopify standard
      });
  });

  syncHeaderCount();
})();
